<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            api-url="entrance/lists/entrancePackage"
            :show-submit-and-clear-btn="false"
            :show-list-btn="false"
            :canDelete="item.id >= 1"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="BrandForm"
        >
          <template>
            <v-row>
              <v-col col="12" md="4">
                <v-text-field label="نام پکیج"
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>

              </v-col>
              <v-col col="12" md="4">
                <date
                    v-model="item.registration_date"
                    label="تاریخ"
                    :default="false"
                    :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="4">
                <mtime
                    v-model="item.registration_time"
                    label="ساعت"
                    :default="false"
                    :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="6">
                <v-autocomplete
                    class="rounded-lg"
                    label=" تامین کننده"
                    :items="suppliers"
                    v-model="item.supplier"
                    item-text="name"
                    item-value="value"
                    :disabled="!isEditing"
                />
              </v-col>
              <v-col col="12" md="6">
                <v-autocomplete
                    class="rounded-lg"
                    label=" تحویل به انبار"
                    :items="stores"
                    v-model="item.store"
                    item-text="name"
                    item-value="value"
                    :disabled="!isEditing"
                />
              </v-col>
            </v-row>
            <template v-if="item.id">
              <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                      class="rounded-lg"
                      label=" نوع ثبت پکیج"
                      :items="submit_types"
                      v-model="is_manual"
                      item-text="name"
                      item-value="value"
                      :disabled="!isEditing"
                  />
                </v-col>
              </v-row>
              <v-row v-if="is_manual">
                <v-col cols="12" md="12">
                  <v-card class="primary rounded">
                    <v-card-title>
                      <v-img
                          @click="upload_file_dialog = true"
                          class="mr-2"
                          style="cursor: pointer"
                          contain
                          max-height="50"
                          max-width="50"
                          src="/img/icons/info-white.svg"
                      />
                      <strong class="white--text mr-4">دستی </strong>

                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" md="12">
                  <v-card class="primary rounded-lg elevation-2"
                          @click="upload_file_dialog = true"
                          style="cursor: pointer">
                    <v-card-title>
                      <v-img
                          @click="upload_file_dialog = true"
                          class="mr-2"
                          style="cursor: pointer"
                          v-if="!item.entrance_file"
                          contain
                          max-height="50"
                          max-width="50"
                          src="/img/icons/info-white.svg"
                      />
                      <v-img
                          class="mr-2"
                          v-if="item.entrance_file"
                          contain
                          max-height="50"
                          max-width="50"
                          src="/img/icons/primary_check.svg"
                      />
                      <strong class="white--text mr-4" v-if="item.entrance_file">فایل اکسل آپلود شده </strong>
                      <strong class="white--text mr-4" v-if="!item.entrance_file"> فایل اکسل را آپلود کنید</strong>
                    </v-card-title>
                  </v-card>
                  <template v-if="item.entrance_file && !item.is_inserted">
                    <v-card class="rounded-lg secondary mt-2 elevation-2">
                      <v-card-title class="white--text ">
                        ردیف های اکسل
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="addRowDialog = true"
                            fab
                            color="white"
                            depressed>
                          <v-icon color="primary">fa-plus</v-icon>
                        </v-btn>
                      </v-card-title>

                    <v-card class="white  rounded-lg ma-3"
                            v-for="(row, key) in excelRows">
                      <v-card-text class="primary--text pa-2">
                        <v-row
                            class="ma-2"
                        >
                          <v-icon class="ml-3" color="primary">
                            fa-circle
                          </v-icon>
                          <span class=" primary--text font-weight-bold" style="font-size: 15px">
                          {{ type_display(row.key) }}

                        </span>
                          <v-spacer></v-spacer>
                          <span class=" primary--text font-weight-bold mr-3" style="font-size: 18px">
                        ستون
                          {{ row.column_number }}
                        </span>
                        </v-row>
                      </v-card-text>
                    </v-card>
                      <v-card-actions >
                        <v-spacer>
                        </v-spacer>
                        <v-btn class="success white--text rounded-lg" depressed
                          @click="submitExcelRows(item.id)"
                        >
                          ثبت
                        </v-btn>
                      </v-card-actions>
                    </v-card>

                  </template>

                </v-col>
              </v-row>
            </template>
          </template>
        </m-form>
        <v-row justify="center">
          <v-dialog
              v-model="upload_file_dialog"
              class="rounded-lg"
              persistent
              @click:outside="upload_file_dialog=false"
              max-width="400"
          >
            <v-card class="rounded-lg pa-2">
              <v-card-title class="primary--text text-h5">
                فایل اکسل
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <m-file-input
                        label="فایل اکسل"
                        v-model="entrance_file"
                        :delete-attachment.sync="delete_entrance_file"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="upload_file_dialog = false"
                >
                  بستن
                </v-btn>
                <v-btn
                    color="success"
                    text
                    @click="updateLogo(item)"
                >
                  ثبت
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="addRowDialog"
              class="rounded-lg"
              persistent
              @click:outside="closeAddExcelRowDialog()"
              max-width="700"
          >
            <v-card class="rounded-lg pa-2">
              <v-card-title class="primary--text text-h5">
                اضافه کردن ردیف
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                        class="rounded-lg"
                        label="ستون"
                        :items="row_types"
                        v-model="row_type"
                        item-text="name"
                        item-value="value"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <money
                        class="rounded-lg"
                        label="شماره ستون"
                        v-model="row_number"

                    ></money>
                  </v-col>
                  <v-col cols="12" md="12" v-if="row_type == 'ic'">
                    <v-autocomplete
                        class="rounded-lg"
                        label="نوع قیمت در صورت فروش"
                        :items="in_case_of_sale_types"
                        v-model="in_case_of_sale_type"
                        item-text="name"
                        item-value="value"
                    />

                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="closeAddExcelRowDialog()"
                >
                  بستن
                </v-btn>
                <v-btn
                    color="success"
                    text
                    @click="addExcelRow()"
                >
                  اضافه کردن
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import Time from "@/components/mcomponents/cleave/Time";


export default {
  name: "EntrancePackageForm",
  components: {Time},
  mixins: [MFormMixin, formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'entrance/entrancePackage/all',
      baseUrl: "entrance/entrancePackage",
      permissionBasename: "entrance_package",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      delete_entrance_file: null,
      entrance_file: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      upload_file_dialog: false,
      suppliers: [],
      excelRows: [],
      stores: [],
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      addRowDialog: false,
      items: [],
      first: false,
      is_manual: false,
      submit_types: [
        {name: ' دستی', value: true},
        {name: 'فایل اکسل', value: false},
      ],
      row_type: null,
      row_number: null,
      in_case_of_sale_type: null,
      row_types: [
        {name: ' مبلغ محصول', value: 'pp'},
        {name: 'نام محصول', value: 'pn'},
        {name: 'کد محصول', value: 'pc'},
        {name: 'تعداد کارتون', value: 'nb'},
        {name: 'تعداد محصول در کارتون', value: 'pb'},
        {name: 'کد 16 رقمی', value: 'sd'},
        {name: 'قیمت در صورت فروش', value: 'ic'},
        {name: 'بارکد', value: 'ba'},
        {name: 'تصویر', value: 'im'},
      ],
      in_case_of_sale_types: [
        {name: 'مبلغ', value: 'a'},
        {name: 'درصد', value: 'p'},
      ],

      cols: [
        {
          text: "نام",
          value: "name",
        },
      ],

    };
  },
  computed: {
    title() {
      return 'package'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
    this.getStores()
    this.getSuppliers()
  },
  methods: {
    getUpdateLogoSerialized(selectItem) {
      let item = {
        id: selectItem.id,
        entrance_file: this.entrance_file,
        delete_entrance_file: this.entrance_file,
      };

      if (typeof item["logo"] == typeof "") {
        delete item["logo"];
      }

      return this.jsonToFormData(item);
    },

    updateLogo(selectItem) {
      this.request({
        url: this.endpoint(`entrance/fileUpload/${selectItem.id}`),
        method: "put",
        data: this.getUpdateLogoSerialized(selectItem),
        success: (data) => {
          this.successNotify();
          this.isEditing = false;
          this.upload_file_dialog = false
          this.$refs.BrandForm.$refs.datatable.getDataFromApi()
        },
      });
    },

    getSuppliers() {
      this.request({
        url: this.endpoint(`main/supplier`),
        method: "get",
        success: data => {
          this.suppliers = []
          for (let supplier of data) {
            this.suppliers.push({
              'name': supplier.name,
              'value': supplier.id,
            })
          }
        }
      })
    },
    getStores() {
      this.request({
        url: this.endpoint(`main/store`),
        method: "get",
        success: data => {
          this.stores = []
          for (let store of data) {
            this.stores.push({
              'name': store.name,
              'value': store.id,
            })
          }
        }
      })
    },
    check_type_in_row(row_type) {
      for (let row of this.excelRows) {
        if (row['key'] == row_type) {
          return true
        }
      }
      return false
    },
    type_display(row_type) {
      for (let row of this.row_types) {
        if (row['value'] == row_type) {
          return row['name']
        }
      }
      return ''
    },
    check_number_in_row(row_number) {
      for (let row of this.excelRows) {
        if (row['column_number'] == row_number) {
          return true
        }
      }
      return false
    },
    closeAddExcelRowDialog() {
      this.addRowDialog = false
      this.row_number = null
      this.row_type = null
    },
    addExcelRow() {
      if (!this.row_type || !this.row_number) {
        this.notify('شماره یا نوع ستون خالی است', 'error')
      } else if (this.check_type_in_row(this.row_type)) {
        this.notify('نوع ستون تکراری است', 'error')
      } else if (this.check_number_in_row(this.row_number)) {
        this.notify('شماره ستون تکراری است', 'error')
      } else {
        this.excelRows.push(
            {
              key: this.row_type,
              column_number: this.row_number,
              is_in_case_of_sale: this.row_type == 'ic',
              in_case_of_sale_type: this.in_case_of_sale_type
            }
        )
        this.addRowDialog = false
        this.row_type = null
        this.row_number = null
        this.in_case_of_sale_type = null
      }
    },
    submitExcelRows(id) {
      this.request({
        url: this.endpoint(`entrance/entrancePackageInsertExcel`),
        method: "post",
        data: {
          packages_columns: this.excelRows,
          entrance_package: id,
        },
        success: (data) => {
          this.successNotify()
        },
      });

    }
  },
}
</script>

<style scoped lang="scss"></style>

